import { useAuth } from '@/auth/useAuth';
import { User } from '@/types';
import axios from 'axios';
import { useState } from 'react';

export function EmailVerificationBanner() {
    const auth = useAuth();
    const user = auth.user as User;

    const [sent, setSent] = useState(false);
    const [throttled, setThrottled] = useState(false);
    const [processing, setProcessing] = useState(false);

    if (!user || user.email_verified_at) {
        return null;
    }

    const handleResend = async () => {
        setProcessing(true);
        setThrottled(false);
        try {
            await axios.post(route('verification.send'));
            setSent(true);
        } catch (error: any) {
            if (error.response?.status === 429) {
                setThrottled(true);
            }
        } finally {
            setProcessing(false);
        }
    };

    return (
        <div className='border-b border-amber-200 bg-amber-50 px-4 py-3'>
            <div className='mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-2'>
                <p className='text-sm text-amber-800'>
                    Please verify your email address. Check your inbox at <strong>{user.email}</strong> for a
                    verification link.
                </p>
                {sent ? (
                    <span className='shrink-0 text-sm font-medium text-amber-900'>Sent!</span>
                ) : throttled ? (
                    <span className='shrink-0 text-sm text-amber-700'>Too many attempts — please wait a minute.</span>
                ) : (
                    <button
                        onClick={handleResend}
                        disabled={processing}
                        className='shrink-0 text-sm font-medium text-amber-900 underline hover:text-amber-700 disabled:opacity-50'
                    >
                        Resend verification email
                    </button>
                )}
            </div>
        </div>
    );
}
